import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie, removeCookie } from 'utils/functions-cookie'

export type ref = 'REWARD' | 'PURCHASE'

type getWalletCompanyProps = {
  company_id: string
  reference: ref
  offset?: number
  limit?: number
}

export const getWalletCompanyTransactions = async ({
  company_id,
  reference,
  offset = 0,
  limit = 10,
}: getWalletCompanyProps) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(
    `${BASE_URL_API}/companies/wallet/${company_id}/transactions/${reference}?offset=${offset}&limit=${limit}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    },
  )

  if (response.status === 401) {
    throw new Error('Sessão expirada')
  }

  if (response.status === 403) {
    removeCookie('auth_token')
    window.location.reload()
  }

  return response.json()
}
